import {
	DELETE_CONVERSATION,
	DELETE_CONVERSATION_SUCCESS,
	DELETE_CONVERSATION_FAIL,
	DELETE_CONVERSATION_RESET,
} from '../actions/deleteConversationAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const deleteConversationReducer = (state = initialState, action) => {
	switch (action.type) {
		case DELETE_CONVERSATION:
			return {
				...state,
				apiState: 'loading',
			};
		case DELETE_CONVERSATION_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message || 'success',
			};
		case DELETE_CONVERSATION_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors || null,
				message: action.response.message || 'error',
			};
		case DELETE_CONVERSATION_RESET:
			return initialState;
		default:
			return state;
	}
};

export default deleteConversationReducer;
